module.exports = __webpack_public_path__ + "static/media/cases_brand_riovermelho_06.2921befe.jpg";